import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['it', 'en'] as const,
  defaultLocale: 'it',
  // 'always' = every URL has a locale prefix. Per D012, this is locked.
  localePrefix: 'always',
});

export type Locale = (typeof routing.locales)[number];
